import React from 'react';
interface CtaButtonProps {
  href: string;
  children: React.ReactNode;
  size?: 'md' | 'lg';
  external?: boolean;
  className?: string;
}
export function CtaButton({
  href,
  children,
  size = 'md',
  external = false,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex w-full items-center justify-center rounded-xl border-2 border-navy bg-cta font-display font-extrabold uppercase leading-tight tracking-wide text-white text-center [text-shadow:0_1px_1px_rgb(16_43_85/0.45)] shadow-[0_5px_0_0_theme(colors.navy)] transition-[transform,background-color,box-shadow] duration-150 ease-out hover:bg-cta-dark active:translate-y-[3px] active:shadow-[0_2px_0_0_theme(colors.navy)]';
  const sizes: Record<string, string> = {
    md: 'px-4 py-3 text-sm sm:text-base',
    lg: 'px-4 py-3.5 text-base sm:text-lg'
  };
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : undefined} className={`${base} ${sizes[size]} ${className}`} data-id="element-186" data-mp="137bttoctxbwa">
      {children}
    </a>;
}